<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Configure Lightspeed Customer Groups</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <h3 *ngIf="loadingLightspeedCustomerGroups" class="text-secondary">Loading groups...</h3>

    <ng-container *ngIf="!loadingLightspeedCustomerGroups">
      <label>Rank your Lightspeed customer groups, and select which will be managed by Capitan:</label>

      <div class="alert alert-info">
        Lightspeed only allows a customer to be assigned to a single group, so the groups must be ranked in order to determine which group is used when a customer qualifies for multiple. Lower numbers mean higher ranks.
        <br>
        Groups managed by Capitan will be available for selection when configuring memberships and associations. Capitan will never add customers to Lightspeed customer groups which are not managed by Capitan, and Capitan will only remove customers from non-managed customer groups if the customer qualifies for a higher-ranked group.
      </div>

      <table class="table table-12px mb-3">
        <thead>
          <tr>
            <th>Group Name</th>
            <th>Managed?</th>
            <th>Rank</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let scg of lightspeedCustomerGroupList">
            <td style="padding-top: 16px">
              {{ scg.name }}
            </td>
            <td style="padding-top: 14px">
              <input type="checkbox"
                     id="scgManaged{{ scg.id }}" name="scgManaged{{ scg.id }}"
                     [(ngModel)]="scg.is_managed_by_capitan">
            </td>
            <td class="table-12px-button-cell">
              <input type="number" step="1"
                     id="scgRank{{ scg.id }}" name="scgRank{{ scg.id }}"
                     [(ngModel)]="scg.rank"
                     class="form-control form-control-sm" style="max-width: 80px">
            </td>
          </tr>
          <tr *ngIf="lightspeedCustomerGroupList.length === 0">
            <td colspan="99" class="text-muted">
              No customer groups configured in Lightspeed
            </td>
          </tr>
        </tbody>
      </table>

      <div class="alert alert-warning">
        If a group is removed from the list of managed groups, it will be removed from any assigned memberships and associations, and any customers which have automatically be added to the group by Capitan will remain in the group indefinitely (unless they qualify for a higher-ranked group).
      </div>
    </ng-container>

    <div class="alert alert-danger" *ngIf="errorMessage !== ''">
      {{ errorMessage }}
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button class="btn btn-primary"
            (click)="handleSubmit()"
            *ngIf="!loadingSave">
      Save
    </button>
    <button class="btn btn-primary disabled" type="button" disabled
            *ngIf="loadingSave">
      Loading...
    </button>
  </div>

</ng-container>
